import { useCallback, useEffect, useState } from 'react';
import { getConfiguredBillingRuts } from '../services/ElectronicBillingService';

/** `allLocations`: una entrada por sucursal en vez de una por RUT (para datos propios de cada sucursal). */
const useConfiguredBillingRuts = ({ allLocations = false } = {}) => {
  const [ruts, setRuts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(false);

    try {
      const configuredRuts = await getConfiguredBillingRuts({ allLocations });
      setRuts(configuredRuts);
    } catch (fetchError) {
      console.error('Error fetching configured billing RUTs', fetchError);
      setRuts([]);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [allLocations]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { ruts, loading, error, reload };
};

export default useConfiguredBillingRuts;
